<main class="em-l-container main-content">
  <!-- Breadcrumbs -->
  <supplier-breadcrumbs [items]="breadcrumbItems"></supplier-breadcrumbs>

  <div *ngIf="loading">
    <app-loader></app-loader>
  </div>

  <div *ngIf="!loading">
    <!-- Header -->
    <div class="em-l-grid em-l-grid--2up">
      <div class="em-l-grid__item">
        <span class="supplier-name">{{ supplierName }}</span>
      </div>
      <div class="em-l-grid__item">
        <div class="menubar-container">
          <!-- Search bar -->
          <div
            class="em-c-search-form em-js-header-search menubar-container__searchbar"
          >
            <label for="search" class="em-c-search__label em-u-is-vishidden"
              >Search</label
            >
            <div class="em-c-field em-is-readonly">
              <div class="em-c-field__body">
                <input
                  class="em-c-input em-js-input"
                  placeholder="search"
                  [(ngModel)]="searchString"
                />
                <svg
                  class="em-c-icon em-c-icon--medium em-c-field__icon em-u-clickable"
                  (click)="clearSearch()"
                >
                  <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="assets/unity-1.6.0/images/24/em-icons.svg#circle-x"
                  ></use>
                </svg>
              </div>
            </div>
          </div>
          <!-- New button -->
          <a
            class="em-c-btn em-c-btn--primary menubar-container__newbutton"
            [routerLink]="[
              '/supplier-profile',
              supplierIdentity,
              'create-detail'
            ]"
            *ngIf="(storeService.user$ | async)?.canMaintainSupplierProfile"
          >
            <div class="em-c-btn__inner">
              <svg
                class="em-c-icon em-c-icon--small em-c-btn__icon"
                data-em-icon-path="assets/unity-1.6.0/images/em-icons.svg"
              >
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="assets/unity-1.6.0/images/em-icons.svg#circle-plus"
                ></use>
              </svg>
              <span class="em-c-btn__text">New</span>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- Display Supplier Profile-->
    <div class="em-l-grid em-l-grid--3up">
      <div
        class="em-l-grid__item detail-card"
        *ngFor="
          let profile of currentSupplierProfile
            | supplierProfileFilter: searchString
        "
      >
        <div class="em-c-solid-card">
          <a
            [routerLink]="[profile.vendCode + '-' + profile.plantCode]"
            class="em-c-solid-card__body top-card"
          >
            <div>
              <div class="info-block">
                <span class="small-title">Vendor Code: </span>
                {{ profile.vendCode }}
              </div>
              <div class="info-block">
                <span class="small-title">Vendor Description: </span>
                {{ profile.vendDescription }}
              </div>
              <div class="info-block">
                <span class="small-title">Plant Code: </span>
                {{ profile.plantCode }}
              </div>
              <div class="info-block">
                <span class="small-title">Plant Description: </span>
                {{ profile.plantDescription }}
              </div>
            </div>
            <svg
              class="em-c-icon em-c-icon--small em-c-solid-card__icon--small"
            >
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="assets/unity-1.6.0/images/em-icons.svg#caret-right"
              ></use>
            </svg>
          </a>
          <div class="em-c-solid-card__footer footer-card">
            Exceptions
            <ul class="em-c-definition-list" *ngIf="profile.exceptions">
              <li
                class="em-c-definition-list__item"
                *ngFor="let exception of profile.exceptions; let i = index"
              >
                <div
                  class="em-c-definition-list__key exception-key"
                  *ngIf="!exception.isDeleted"
                >
                  {{ i + 1 }}. {{ exception.criteria }}
                </div>
                <div
                  class="em-c-definition-list__value"
                  *ngIf="!exception.isDeleted"
                >
                  {{ exception.value }}
                  {{ exception.criteria === "Demand Horizon" ? "Months" : "" }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
